import { ClientLoadModel } from '@numeo/types-core'

export const getCompany = (load: ClientLoadModel): string => String(load?.posterInfo?.companyName ?? 'Unknown')

export const getContactEmail = (load: ClientLoadModel): string | null => load?.posterInfo?.contact?.email ?? null
